var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefrigerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.36 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "refrigerator"
  }, "Refrigerator Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "refrigerator"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85,18.36H4.17A1.4,1.4,0,0,1,2.77,17V13.29a1.4,1.4,0,0,1,1.4-1.4H7.85a1.4,1.4,0,0,1,1.39,1.4V17A1.39,1.39,0,0,1,7.85,18.36ZM4.17,12.89a.4.4,0,0,0-.4.4V17a.39.39,0,0,0,.4.39H7.85A.39.39,0,0,0,8.24,17V13.29a.4.4,0,0,0-.39-.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.06,9.61a.54.54,0,0,1-.36-.14l-6.19-6.2a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l6.2,6.2a.5.5,0,0,1,0,.71A.54.54,0,0,1,26.06,9.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.42,6a.49.49,0,0,1-.35-.15L23.52,3.27a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l2.56,2.55a.51.51,0,0,1,0,.71A.51.51,0,0,1,26.42,6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.28,25.17a.75.75,0,0,1-.75-.75V21.14a.75.75,0,1,1,1.5,0v3.28A.74.74,0,0,1,7.28,25.17Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3,25.17a.75.75,0,0,1-.75-.75V21.14a.75.75,0,0,1,1.5,0v3.28A.74.74,0,0,1,15.3,25.17Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.52,0H2.72A2.75,2.75,0,0,0,0,2.73V42.11a2.75,2.75,0,0,0,2.75,2.75h24.8a2.75,2.75,0,0,0,2.75-2.75V2.73A2.75,2.75,0,0,0,27.52,0Zm-26,42.13V2.73A1.25,1.25,0,0,1,2.72,1.48h8.19V43.36H2.72A1.25,1.25,0,0,1,1.47,42.11Zm27.3,0a1.25,1.25,0,0,1-1.25,1.25H12.41V1.48H27.52a1.25,1.25,0,0,1,1.25,1.25Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.18,47.78H1.43V43.36H29.18ZM2.93,46.28H27.68V44.86H2.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefrigerator);
export default __webpack_public_path__ + "static/media/refrigerator.7417d31d158203ef0bcc1d0d139cc321.svg";
export { ForwardRef as ReactComponent };